<template>
    <img :src="alzataSplash" />
</template>

<script>
import alzataSplash from '../assets/alzata-splash.svg';

export default {
    name: 'AlzataSplashImage',
    data() {
        return {
            alzataSplash,
        };
    },
};
</script>